import React from 'react';

// Cat-paw glyph (big pad + four plump toes). Recolorable via `color` — it is
// pink on the joystick handle and translucent-white on the tap circle, which
// is why this is an inline SVG rather than a fixed-color image asset.
export default function Paw({ className, color = 'currentColor' }) {
  return (
    <svg className={className} viewBox="0 0 100 100" fill={color} aria-hidden="true">
      <ellipse cx="50" cy="64" rx="30" ry="27" />
      <ellipse cx="19" cy="44" rx="13" ry="16.5" />
      <ellipse cx="39.5" cy="25" rx="13.5" ry="18" />
      <ellipse cx="60.5" cy="25" rx="13.5" ry="18" />
      <ellipse cx="81" cy="44" rx="13" ry="16.5" />
    </svg>
  );
}
